<template>
  <div class="a-select" :class="{ '-disabled': disabled, '-invalid': invalid }">
    <select :id="fieldId ? fieldId : name" class="a-select__select" :name="name" :disabled="disabled" @change="inputHandler">
      <option v-if="label" class="a-select__option" disabled value="" :selected="selected == ''">
        {{ label }}
      </option>
      <slot name="options">
        <option
          v-for="option in options"
          :key="option.key"
          class="a-select__option"
          :selected="option.value == selected"
          :hidden="option.hidden"
          :value="option.value"
        >
          {{ $t(option.name) }}
        </option>
      </slot>
    </select>
    <slot name="icon">
      <base-icon class="a-select__icon" icon="chevron-down" />
    </slot>
  </div>
</template>

<script>
import BaseIcon from '@/components/atoms/BaseIcon'
export default {
  name: 'BaseSelect',
  components: {
    BaseIcon
  },
  model: {
    prop: 'selected',
    event: 'change',
  },
  props: {
    fieldId: {
      type: String,
      default: ''
    },
    /**
     * Select field label
     */
    label: {
      type: String,
      default: '',
    },
    /**
     * Selected item value
     */
    selected: {
      type: [String, Number, Object, Array],
      default: '',
    },
    /**
     * Form select name
     */
    name: {
      type: String,
      default: null
    },
    /**
     * Selected item value
     */
    options: {
      type: [Array],
      default () {
        return {};
      },
    },
    disabled: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {

    };
  },
  computed: {
    selectedValue () {
      return (Array.isArray(this.selected) ? this.$firstOrDefault(this.selected) : this.selected)
    }
  },
  created () {

  },
  methods: {
    inputHandler ($event) {
      this.$emit('change', $event.target.value, this.fieldId);
    }
  }
}
</script>
